import { Post } from "../../models/RestModels";

export function getEmptyPost(): Post
{
		return {
			created: new Date(),
			id: 0,
			title: '',
			post: '',
			images_ids: '',
			created_by_user_id: 0,
			updated_by_user_id: 0,
			updated: new Date(),
		};
}
